import { createContext, useContext, type ReactNode } from 'react';

export const DEMO_NAMESPACE_ID = 1511;

export interface DemoNamespaceFilterValue {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  namespaceId: number;
}

const DemoNamespaceFilterContext = createContext<DemoNamespaceFilterValue | null>(null);

export function DemoNamespaceFilterProvider({
  value,
  children,
}: {
  value: DemoNamespaceFilterValue;
  children: ReactNode;
}) {
  return (
    <DemoNamespaceFilterContext.Provider value={value}>
      {children}
    </DemoNamespaceFilterContext.Provider>
  );
}

export function useDemoNamespaceFilter(): DemoNamespaceFilterValue {
  const ctx = useContext(DemoNamespaceFilterContext);
  if (!ctx) {
    throw new Error('useDemoNamespaceFilter must be used within DemoNamespaceFilterProvider.');
  }
  return ctx;
}
